/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserDelegationStatusRequest } from '../../models/update-user-delegation-status-request';
import { UserDelegationRequestResponse } from '../../models/user-delegation-request-response';

export interface UpdateDelegationStatusById$Params {

/**
 * delegation request id
 */
  id: number;
      body: UpdateUserDelegationStatusRequest
}

export function updateDelegationStatusById(http: HttpClient, rootUrl: string, params: UpdateDelegationStatusById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDelegationRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, updateDelegationStatusById.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDelegationRequestResponse>;
    })
  );
}

updateDelegationStatusById.PATH = '/api/administration/delegations/{id}';
